import { Routes } from '@angular/router'

import { AboutViewComponent } from './views/aboutView.component'

export const ROUTES: Routes = [
  ...AboutViewComponent.routes,
]
